module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-Two.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-1"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("Chapter Two")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_vm._v("Christina looked ready to spit nails. Still didn’t detract one bit from her all-around gorgeousness.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He had the advantage knowing about this meeting beforehand, and if there’s one thing he’d learned about his ex-fiancée it was that if you had an advantage over her—exploit it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She reined herself in and the tight lips curved into a tighter smile. “You’re back.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“In the flesh.” He spread his arms, spanning the doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Two spots of color flagged her cheeks and then disappeared almost immediately. She recovered quickly—always had, always would.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I heard you were traipsing around Latin America after your...leave of absence.” Her fingers drummed the papers on the desk.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He kicked the door shut behind him and she jumped. Not so composed after all.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ve been back in the States about a month. Went straight from drugs to serial killers.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you okay with the move?” Her dark, liquid eyes softened as they scanned his face, and her long lashes fluttered against her cheeks.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The edges of his cold resolve melted just a little. Then he straightened his spine. He’d seen that look before—right before she stabbed him in the back.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why not?” He lifted his shoulders in a quick shrug. “I’m particularly suited to the assignment, don’t you agree? Just like I was particularly suited to the kidnapping detail. Let’s just hope this one ends better.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She jumped from her chair, smacking her palms on the desk blotter. “You...”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He held up his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She closed her eyes, adjusted the waistband of her slacks and plopped back in her chair. “You look good.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His gaze strayed from the perfect oval of her face to her long fingers twisting into knots. He could say the same for her. The masculine pantsuit did nothing to conceal her femininity, and from the way she towered over the desk he knew her feet were slipped into those high heels she loved to wear at the office to remind everyone in this male-dominated field that she was still a woman.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Not that there could be any doubt about that. Ever.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You look good, too. Serial killers agree with you. Of course, they always did. You must be in heaven.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A spasm crumpled her face and she shoved the file folders toward him. “Oh, yeah. It’s heaven to see young women like Nora and Olivia cut down in the prime of life by some sick whack job.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Heaving out a long sigh, he rolled a leather-bound chair behind him and dropped into it. The war between them was over. He’d ended the engagement, and these battles were unnecessary. “I’m sorry, Christina. That was a low blow. The families of these women are lucky to have you on their cases.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her lips parted and she nodded. Her mouth had lost the tightness and looked totally kissable—and God he could take her in his arms right now and do justice to those luscious lips.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The lust that slammed him and had him shifting in the squeaky chair hadn’t revved him up like this in over two years—the last time he’d seen Christina Sandoval.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Greavy was a sadistic SOB to put him on this case with Christina. Of course, Greavy had no idea the homicide in San Diego he’d assigned to Eric as soon as he joined the unit would be linked to Christina’s three cases in Portland and San Francisco. This guy got around.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Clearing his throat, he folded his arms behind his head and tipped back in his chair, making it squeak even more. “Did Rich tell you why I was coming out?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Rich didn’t tell me you were coming out at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I mean, did he tell you why another agent was joining you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Typical Greavy. I haven’t spoken to him in person since he sent me to Portland. I had to find out another agent was coming to assist me from Lieutenant Fitch over there.” She spun the file folders around to face him. “And here you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He cocked his head. “Greavy didn’t tell you about the other case in San Diego?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There was another murder in San Diego? Same M.O.?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yep.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A flare of anger turned her cheeks red. “I’m assuming the killer stuck the tarot card with the maiden and lion between the vic’s fingers. Three murders up here, three tarot cards.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“This is where it gets weird. The body had a tarot card between his fingers, all right, but it wasn’t that lion one.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Christina’s eyes widened. “Let me guess. It was a tarot card with a fool on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Eric leaned forward and the front wheels of his chair hit the floor where it skidded a few inches to the right. “How’d you know that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I canvased the area where we found the most recent victim, Nora Sterling. I thought I had a pretty good idea where the killer was hiding before he attacked her—up a tree. I climbed the tree and found the card.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What made you climb the tree?” But he didn’t have to ask. Christina always claimed she could get into the head of a killer. He still didn’t know if he believed her or not, but it could come in handy in this case if she could.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Just...umm, a feeling and some damage to the bark on the trunk.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Do you have the card here?” He shuffled through the papers in the case folders.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s in evidence.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Prints?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“None.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Eric whistled through his teeth. “I wonder if there were any more tarot cards near the body in San Diego.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was wondering the same thing about the murder in Portland and the first one here.” She tapped a pencil against her chin and then dropped it. “Wait. Did you say the victim in San Diego was male?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s right.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Was the body found outdoors? Bludgeoned and then throat slit?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nope—indoors, no bludgeoning, but his throat was slit. He lost an amazing amount of blood that soaked into the carpet and the floorboards beneath.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Same with the other victims. They suffered a lot of blood loss.” She curled her fingers around the arms of the chair. “So the M.O. was a little different for the male victim.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We did find some drugs and alcohol in his system, so maybe the killer incapacitated him that way and didn’t have to hit him over the head.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That suggests he knew him or had some kind of contact with him before the murder. That doesn’t seem to be the case at all with the women.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Christina sucked in her bottom lip, which she always did when she was thinking. She couldn’t just be trying to focus his attention on her mouth, could she? Because he couldn’t keep his eyes, or his nasty thoughts, off her lips.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What could possibly be the connection between these four people?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Clearing his throat, he scratched the stubble on his chin. “I guess it’s up to us to find the connections, because they have to be there.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Us. There hasn’t been an us for a long time.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I think we can be adults and work together.” As soon as he could get his mind out of the gutter.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sure.” She folded her hands on the desk. “How’s your family?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Fine. Yours? How’s your mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’s doing well, busy.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Busy? I thought she retired from nursing.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Christina’s hands got fidgety again, stacking papers and lining up pencils. She’d never been the nervous type before. She’d always had a cool, calm demeanor. As cold as ice—except in the bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Seeing him had rattled her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His response to her had surprised him, too. He accepted the fact that he’d never forget Christina, no matter what she’d done to him, but he’d believed he could tame the visceral reaction she’d always elicited from him. Not so much.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He dragged his gaze away from her puckered lips as she blew a strand of dark hair from her face.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She did retire, but she picked up a bunch of hobbies.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good for her.” He pointed at the folders. “How about it? Do you want to get a couple of sandwiches delivered and dig in to what we got?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sounds good. I’ll ask our new best friend, Officer Griego, for some suggestions.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, there’s some hero worship going on there.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You always did have the ladies fawning over you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He raised one eyebrow. “I was talking about you. From the minute she volunteered to take me to you, it was Agent Sandoval this, Agent Sandoval that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Christina gave an unladylike snort. “Did you set her straight?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I didn’t have time.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her nostrils flared as she reached for the phone and punched the speaker button and three other buttons. “Hi, Officer Griego. Can you recommend a good take-out place in the area for lunch?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“One of the sergeants is taking orders now for the deli down the street. I’ll send him over.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That would be great. Menu?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll bring one to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Christina rolled her eyes at him. “That’s not necessary. We’ll come out and have a look.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s okay, ma’am. I know you and Agent Brody are busy. I’ll bring the menu right in. Sarge won’t mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thanks, Officer Griego.” She pressed the speaker button and ended the call.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Eric twisted his lips into a smile. “I’m sure Sarge "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("will")]), _vm._v(" mind catering to the two fibbies in his midst.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“They seem okay with me here, so far. Have you met Lieutenant Fitch yet? I had him eating out of my hand yesterday, but he turned cold once he knew you were on the way.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t get these guys. They should be happy for the help. My brother Ryan always is.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Is he still working up the coast in Crestview?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yep.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Officer Griego peered through the window waving the menu and knocked on the door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Eric scooted his chair back and opened the door. “C’mon in.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She thrust the menu at him. “It’s pretty basic.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s what we like—basic.” He tossed the menu to Christina.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Wrinkling her nose, she ran the tip of her finger down the glossy page. “I’ll take the California on sourdough, but...”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No mayo and extra pickles.” Eric finished for her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She tilted her head, her shiny, dark ponytail slipping over her shoulder. “That predictable, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Warmth spread through his chest. He hadn’t meant to finish her sentence, didn’t want her to know how much he remembered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, you always were kind of picky.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rita was standing at the door hanging on their every word, wide-eyed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Eric glanced at the menu and handed it back to her saying, “The Italian, fries and a drink—something with caffeine.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll give your order to Sergeant Hammond. It usually takes about forty-five minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Eric reached into his pocket for some cash and handed her two twenties. “Thanks, Rita and thank the sarge for us, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re welcome. Anything else I can do for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Christina gave her one of her sweet smiles that seemed to have gotten even sweeter. “We’re good. Thanks so much for your help.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rita practically bowed out of the room, closing the door behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Eric jerked his thumb at the door. “What do you think she expects out of all this? It’s not like you can give her a recommendation for homicide.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe she thinks you can pull some strings with your brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sean? Rita’s in the same department. She should know by now Detective Sean Brody is not a quid pro quo kinda guy. He expects everyone to work hard to get ahead.” He leveled a finger at Christina. “Besides, it’s you she idolizes.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I think she just wants to learn. The men in the department probably aren’t very encouraging and maybe she doesn’t have any role models here.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You didn’t need any role models.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was a special case. Didn’t you always tell me that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Drawing his chair toward the desk, he hunched forward. “What drove you up that tree, Christina?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I told you—a hunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“One of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("those")]), _vm._v(" hunches? Did you feel anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She squeezed her eyes closed and massaged her left temple. “Incredible evil.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Did you tell the P.D. here?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She gave a short laugh, almost a bark. “Are you kidding? I want to be taken seriously, not written off as a crackpot.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The Bureau has used psychics before.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’d hardly call myself a psychic, and honestly, the Bureau may use them but most don’t respect them. Greavy sure doesn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Like I told you before, it’s a talent you should try to develop.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She hugged herself. “I don’t know if I want to develop it. Besides, in this case, I didn’t get much at all, just a feeling.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Up to you.” Eric checked his watch. “Let’s get started before lunch gets here.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Umm, do you want to wheel around here? I’ll take you through the first San Francisco murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He walked his chair to her side of the desk and at once her scent overwhelmed him. The familiar musky perfume wrapped its tendrils around him, but the essence of Christina had a stronger impact on him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He couldn’t put his finger on it. He never could and it had haunted him ever since the day he cut her loose.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She dragged a file folder between them on the desk and flipped it open. She spread a stack of photos in front of him, and green, leafy, verdant forest blurred together.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Was it another running trail?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hiking, just across the bay.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He thumbed through the photos. “Victim?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Liz Fielding, late forties, single. Some trouble in her past but clean for at least five years.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What kind of trouble?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Some drugs, petty theft, a little hooking.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What about the other two?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Haven’t dug up anything like that yet, but the investigation is still young.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He plucked out the pictures of the body. She’d been positioned like his male victim in San Diego—stretched out on her back, hands positioned over her stomach, the tarot slipped between her fingers. He traced a finger over her disheveled clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No sexual assault, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nope, not for any of the victims. Your guy?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No.” He shook out another photo, this one a close-up of the victim’s throat and the ghastly, gaping wound. A necklace clung to the woman’s neck, still intact.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Eric’s pulse jumped and he held the picture closer to his face.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What is it? You see something?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He dropped the photo and he jabbed a finger at the victim’s throat. “This necklace...same one my kidnapper wore.”")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-1"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-623409d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterTwo.vue
// module id = 81
// module chunks = 0